import { default as AnalyticsSender } from "../AnalyticsSender";
import { fetchProfileDataIfAvailable } from "../fetchProfileDataIfAvailable";
import { getBrowserAnalyticsData } from "./browserInfo";
export async function forceUserAuthentication(params, sessionData) {
    const game = params.game;
    const profile = await fetchProfileDataIfAvailable(game);
    const gameData = game == null ? undefined : profile?.ConnectedGames.find((el) => el.Game.toLowerCase() === game.toLowerCase());
    const sendedObject = {
        event: "sdk_user_authentication_forced",
        ...params,
        account_id: profile?.AccountId,
        user_id: gameData?.GameUid,
        email: profile?.Email
    };
    window.dataLayer?.push(sendedObject);
    // Отправка в ClickHouse
    await AnalyticsSender.SendSdkUserAuthenticationForced(sessionData.sessionId, params.game, params.adapter, params.provider_id, sessionData.timeFromSessionStart);
}
export async function logUserInFxId(params, sessionData) {
    const game = params.game;
    const profile = await fetchProfileDataIfAvailable(game);
    const gameData = game == null ? undefined : profile?.ConnectedGames.find((el) => el.Game.toLowerCase() === game.toLowerCase());
    const sendedObject = {
        event: "sdk_user_logged_in_fxid",
        ...params,
        account_id: profile?.AccountId,
        user_id: gameData?.GameUid,
        email: profile?.Email
    };
    window.dataLayer?.push(sendedObject);
    // Получаем данные браузера для аналитики (передаем название игры для привязки session_number)
    const browserData = getBrowserAnalyticsData(params.game);
    // Отправка в ClickHouse
    await AnalyticsSender.SendSdkUserLoggedInFxid(sessionData.sessionId, params.game, params.adapter, browserData.domain, browserData.screenResolution, browserData.os, browserData.browser, browserData.browserVersion, browserData.sessionNumber, sessionData.timeFromSessionStart);
}
export async function openIframeModal(params, sessionData) {
    const game = params.game;
    const profile = await fetchProfileDataIfAvailable(game);
    const gameData = game == null ? undefined : profile?.ConnectedGames.find((el) => el.Game.toLowerCase() === game.toLowerCase());
    const sendedObject = {
        event: "sdk_iframe_modal_opened",
        ...params,
        account_id: profile?.AccountId,
        user_id: gameData?.GameUid,
        email: profile?.Email
    };
    window.dataLayer?.push(sendedObject);
    // Отправка в ClickHouse
    await AnalyticsSender.SendSdkIframeModalOpened(sessionData.sessionId, params.game, params.adapter, params.url, sessionData.timeFromSessionStart);
}
export async function changeLanguage(params, sessionData) {
    const game = params.game;
    const profile = await fetchProfileDataIfAvailable(game);
    const gameData = game == null ? undefined : profile?.ConnectedGames.find((el) => el.Game.toLowerCase() === game.toLowerCase());
    const sendedObject = {
        event: "sdk_language_changed",
        ...params,
        account_id: profile?.AccountId,
        user_id: gameData?.GameUid,
        email: profile?.Email
    };
    window.dataLayer?.push(sendedObject);
    // Отправка в ClickHouse
    await AnalyticsSender.SendSdkLanguageChanged(sessionData.sessionId, params.game, params.adapter, params.old_lang, params.new_lang, sessionData.timeFromSessionStart);
}
export async function reportIssue(params, sessionData) {
    const game = params.game;
    const profile = await fetchProfileDataIfAvailable(game);
    const gameData = game == null ? undefined : profile?.ConnectedGames.find((el) => el.Game.toLowerCase() === game.toLowerCase());
    const sendedObject = {
        event: "sdk_report_modal_opened",
        ...params,
        account_id: profile?.AccountId,
        user_id: gameData?.GameUid,
        email: profile?.Email
    };
    window.dataLayer?.push(sendedObject);
    // Отправка в ClickHouse
    await AnalyticsSender.SendSdkReportModalOpened(sessionData.sessionId, params.game, params.adapter, sessionData.timeFromSessionStart);
}
export async function buyProductRequested(params, sessionData) {
    const game = params.game;
    const profile = await fetchProfileDataIfAvailable(game);
    const gameData = game == null ? undefined : profile?.ConnectedGames.find((el) => el.Game.toLowerCase() === game.toLowerCase());
    const sendedObject = {
        event: "sdk_product_purchase_requested",
        ...params,
        account_id: profile?.AccountId,
        user_id: gameData?.GameUid,
        email: profile?.Email
    };
    window.dataLayer?.push(sendedObject);
    // Отправка в ClickHouse
    await AnalyticsSender.SendSdkProductPurchaseRequested(sessionData.sessionId, params.game, params.adapter, params.product_sku, sessionData.timeFromSessionStart);
}
export async function buyProductCompleted(params, sessionData) {
    const game = params.game;
    const profile = await fetchProfileDataIfAvailable(game);
    const gameData = game == null ? undefined : profile?.ConnectedGames.find((el) => el.Game.toLowerCase() === game.toLowerCase());
    const sendedObject = {
        event: "sdk_product_purchase_completed",
        ...params,
        account_id: profile?.AccountId,
        user_id: gameData?.GameUid,
        email: profile?.Email
    };
    window.dataLayer?.push(sendedObject);
    // Отправка в ClickHouse
    await AnalyticsSender.SendSdkProductPurchaseCompleted(sessionData.sessionId, params.game, params.adapter, params.product_sku, params.currency, params.transaction_id, sessionData.timeFromSessionStart, params.currency_amount, params.usd_amount);
}
export async function buyProductError(params, sessionData) {
    const game = params.game;
    const profile = await fetchProfileDataIfAvailable(game);
    const gameData = game == null ? undefined : profile?.ConnectedGames.find((el) => el.Game.toLowerCase() === game.toLowerCase());
    const sendedObject = {
        event: "sdk_product_purchase_error",
        ...params,
        account_id: profile?.AccountId,
        user_id: gameData?.GameUid,
        email: profile?.Email
    };
    window.dataLayer?.push(sendedObject);
    // Отправка в ClickHouse
    await AnalyticsSender.SendSdkProductPurchaseError(sessionData.sessionId, params.game, params.adapter, params.product_sku, params.error, sessionData.timeFromSessionStart);
}
export async function gameStart(params, sessionData) {
    const game = params.game;
    const profile = await fetchProfileDataIfAvailable(game);
    const gameData = game == null ? undefined : profile?.ConnectedGames.find((el) => el.Game.toLowerCase() === game.toLowerCase());
    const sendedObject = {
        event: "sdk_game_started",
        ...params,
        account_id: profile?.AccountId,
        user_id: gameData?.GameUid,
        email: profile?.Email
    };
    window.dataLayer?.push(sendedObject);
    // Отправка в ClickHouse
    await AnalyticsSender.SendSdkGameStarted(sessionData.sessionId, params.game, params.adapter, sessionData.timeFromSessionStart);
}
//# sourceMappingURL=sdkEvents.js.map